<script>
import CardCurso from '@components/CardCurso'
import { mapState } from 'vuex'

export default {
  name: 'AreaCursosDemo',
  components: {
    CardCurso
  },
  props: {
    scale: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapState(['cursosDemo']),
    styles () {
      const length = this.cursosDemo?.length ?? 1
      return {
        cursosDemoContainer: {
          '--cols': ({
            xs: length < 2 ? length : 2,
            sm: length < 4 ? length : 4,
            md: length < 6 ? length : 6,
            lg: length < 8 ? length : 8,
            xl: length < 12 ? length : 12
          })[this.rl.breakpoint],
          '--max-cols': ({
            xs: 2,
            sm: 4,
            md: 6,
            lg: 8,
            xl: 12
          })[this.rl.breakpoint]
        }
      }
    }
  }
}
</script>

<template>
  <section
    v-if="cursosDemo && cursosDemo.length > 0"
    class="area-cursos-demo"
  >
    <p
      class="view-home-cadastre-se"
      v-html="wl.strings['view-home-cadastre-se']"
    />
    <div
      class="cursos-demo-container"
      :style="styles.cursosDemoContainer"
    >
      <CardCurso
        v-for="curso in cursosDemo"
        :key="curso.id"
        :img="curso.imagem"
        :scale="scale"
        @click="$emit('click', curso)"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
  .area-cursos-demo {
    padding: calc(30px * var(--scale)) var(--margin);
    background-color: var(--surface-light);
    color: var(--on-surface-light);
    .view-home-cadastre-se {
      text-align: center;
      margin-top: 0;
      text-transform: uppercase;
      font: normal calc(32px * var(--scale))/calc(48px * var(--scale)) 'Open Sans';
    }
    .cursos-demo-container {
      --gap: calc(10px * var(--scale));
      --margin-2x: 2 * var(--margin);
      --largura-total-sem-margem: calc(100vw - var(--margin-2x));
      --total-gap: calc(var(--max-cols) * var(--gap));
      --total-items-width: calc(var(--largura-total-sem-margem) - var(--total-gap));
      --item-width: calc(var(--total-items-width) / var(--max-cols));
      width: calc((var(--item-width) * var(--cols)) + ((var(--cols) - 1) * var(--gap)));
      display: grid;
      grid-template-columns: repeat(var(--cols), var(--item-width));
      gap: var(--gap);
      justify-items: center;
      margin: 0 auto;
      div {
        width: var(--item-width);
        height: calc(var(--item-width) * 1.1778);
      }
    }
  }
</style>
